import taaounityLogo from '../logos/taaounity-mark.png';

export default function MarketplaceLogo({ className = '', title = 'Taaouniaty marketplace' }) {
  return (
    <img
      src={taaounityLogo}
      alt={title}
      className={`shop-logo ${className}`.trim()}
    />
  );
}
